function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M220.6 142.5c0-44.3-35.9-80.3-80.3-80.3-15.9 0-31.4 4.7-44.6 13.5L85.5 65.5l15-15-20.1-20.2-15 15-16.8-16.8h24.1V0H0v72.9l28.1.2.1-24.6 17 17-14.9 14.9 20.2 20.2 14.9-14.9 9.9 9.9c-26 35.9-18 86.1 17.9 112 10.1 7.3 21.8 12.2 34.2 14.2v11.8h-21.2v28.5h21.2v21.4h28.4v-21.4H177v-28.5h-21.2v-12.3c37.6-7.4 64.8-40.5 64.8-78.8zm-132.2 0c0-28.6 23.2-51.8 51.8-51.8s51.8 23.2 51.8 51.8-23.2 51.8-51.8 51.8c-28.5 0-51.7-23.2-51.8-51.8z"
})));